import script from "./NotificationsForStudentsSubpage.vue?vue&type=script&lang=ts&setup=true"
export * from "./NotificationsForStudentsSubpage.vue?vue&type=script&lang=ts&setup=true"

import "./NotificationsForStudentsSubpage.vue?vue&type=style&index=0&id=621647bc&lang=scss&scoped=true"

import exportComponent from "/builds/snedson/snotra-backend/snotra-front-ts/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-621647bc"]])

export default __exports__